export default {"src":"/_next/static/media/bg_yellow_t.4dd714b1.svg","height":698,"width":1023,"blurWidth":0,"blurHeight":0};